export default "__VITE_ASSET__IzT1UB1G__"